<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/diyabianping" />
          <div class="ProductImages">
            <div class="image-div">
              <p style=" font-size: 16px; line-height: 30px">0.75-800KW高性能矢量型变频器</p>
              <img :src="baseApi+ 'upload/product/2001.png'">
            </div>
            <div class="image-div">
              <img :src="baseApi+ 'upload/product/2002.png'">
              <img :src="baseApi+ 'upload/product/2003.png'">
            </div>
            <div class="image-div">
              <img :src="baseApi+ 'upload/product/2004.png'">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/view/componets/Banner'
import Tab from '@/views/view/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.ProductImages {
  display: flex;
  .image-div {
    width: 30%;
    margin: 30px 10px;
    img {
      width: 100%;
      //margin: 20px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view/diyabianping.vue